module.exports = __webpack_public_path__ + "static/img/part1.a1bd418.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/activity4/part1.png
// module id = /ChU
// module chunks = 7